import _ from "lodash";
import { FC, useCallback, useState } from "react";
import { StyleSheet, Text, TextInput, View } from "react-native";
import { useSelector } from "react-redux";
import { useAppDispatch } from "src/redux";
import { kColors } from "src/kColors";
import { kFonts } from "src/kFonts";
import { kStyleConst } from "src/kStyle";
import { adminUpdateUserEmail } from "src/redux/AdminUser/actions";
import { Modal } from "..";

const NewEmailModal: FC<{ sendFunction: () => void; cancelFunction: () => void }> = ({
  sendFunction,
  cancelFunction,
}) => {
  const dispatch = useAppDispatch();
  const [sEmail, setEmail] = useState("");
  const [sConfirmEmail, setConfirmEmail] = useState("");
  const rAdminUserSettings = useSelector(({ AdminUserReducer }) => AdminUserReducer);

  const sendEmail = useCallback(() => {
    if (sConfirmEmail === sEmail) {
      dispatch(adminUpdateUserEmail(sEmail, rAdminUserSettings));

      sendFunction();
    }
  }, [dispatch, rAdminUserSettings, sConfirmEmail, sEmail, sendFunction]);

  return (
    <Modal
      title="Change Email"
      subtitle="This will change a users login email. Only do this if you are sure"
      buttons={[
        {
          id: "change-email-modal-secondary",
          label: "Cancel",
          onPress: cancelFunction,
          type: "secondary",
        },
        {
          id: "change-email-modal-primary",
          label: "Submit",
          onPress: sendEmail,
          type: "primary",
          isPrimaryAction: true,
        },
      ]}
      onCancel={cancelFunction}
    >
      <View style={styles.gFormRowNoMargin}>
        <View style={styles.gLinkBankFormItem}>
          <Text style={styles.P08_01_InputHeader}>Email</Text>
          <TextInput onChangeText={setEmail} placeholder="email@example.com" style={styles.gLinkBankInput} />
        </View>
        <View style={styles.gLinkBankFormItemNoMargin}>
          <Text style={styles.P08_01_InputHeader}>Confirm Email</Text>
          <TextInput onChangeText={setConfirmEmail} placeholder="confirm" style={styles.gLinkBankInput} />
        </View>
      </View>
    </Modal>
  );
};
export default NewEmailModal;

const styles = StyleSheet.create({
  P08_01_InputHeader: {
    ...kFonts.formLegend,
  },
  gFormRowNoMargin: {
    alignItems: "flex-start",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "space-between",
    minWidth: kStyleConst.kApplyMinWidth,
  },
  gLinkBankFormItem: {
    flexGrow: 1,
    marginBottom: 3 * kStyleConst.kSpacing,
    marginRight: 8 * kStyleConst.kSpacing,
    marginTop: 6 * kStyleConst.kSpacing,
  },
  gLinkBankFormItemNoMargin: {
    flexGrow: 1,
    marginBottom: 3 * kStyleConst.kSpacing,
    marginTop: 6 * kStyleConst.kSpacing,
    // marginVertical: 8 * kStyleConst.kSpacing,
  },
  gLinkBankInput: {
    borderBottomWidth: 1,
    borderColor: kColors.brandPink,
    borderRadius: 2,
    flex: 1,
    height: 36,
    marginLeft: 0,
    marginTop: 5,
    minWidth: kStyleConst.kApplyMinWidth,
    outlineColor: kColors.transparent,
    paddingLeft: kStyleConst.kSpacing,
    paddingVertical: 2 * kStyleConst.kSpacing,
  },
});
